// extracted by mini-css-extract-plugin
module.exports = {"ChatViewWrapper":"ChatView_ChatViewWrapper__3oeaO","ChatViewDivider":"ChatView_ChatViewDivider__3yVX6"};